import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import RaffleCard from "@/components/RaffleCard";
import { ArrowRight, Sparkles, Trophy, ShieldCheck, Smartphone } from "lucide-react";

const MARQUEE_TEXT = "¡COMPRA TU RIFA Y GANA! · PAGA CON YAPE · 100% TRANSPARENTE · ";

export default function Landing() {
    const [raffles, setRaffles] = useState([]);

    useEffect(() => {
        api.get("/raffles/featured").then((r) => setRaffles(r.data)).catch(() => {});
    }, []);

    return (
        <div data-testid="landing-page">
            {/* HERO */}
            <section className="relative border-b-2 border-ink overflow-hidden">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 grid lg:grid-cols-12 gap-10 items-center">
                    <div className="lg:col-span-7 space-y-8">
                        <div className="inline-flex items-center gap-2 border-2 border-ink bg-mint px-3 py-1 shadow-brut-sm">
                            <Sparkles className="w-4 h-4" strokeWidth={3} />
                            <span className="text-xs font-bold uppercase tracking-widest">Plataforma de rifas #1 en Perú</span>
                        </div>
                        <h1 className="font-display font-black text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight uppercase">
                            Crea, vende y <span className="bg-coral text-white px-3 inline-block -rotate-1 border-2 border-ink shadow-brut">gana</span>
                            <br />
                            con tu propia rifa.
                        </h1>
                        <p className="text-lg max-w-xl text-ink/80">
                            Lanza tu rifa en minutos, recibe pagos con Yape y deja que tus participantes elijan sus números favoritos. Todo en un solo lugar.
                        </p>
                        <div className="flex flex-wrap gap-3">
                            <Link to="/rifas" className="brut-btn brut-btn-primary" data-testid="hero-cta-explore">
                                Ver rifas activas <ArrowRight className="w-4 h-4" strokeWidth={3} />
                            </Link>
                            <Link to="/register" className="brut-btn" data-testid="hero-cta-register">
                                Crear mi rifa
                            </Link>
                        </div>
                        <div className="flex flex-wrap gap-6 pt-4 text-xs uppercase tracking-widest font-bold">
                            <div className="flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-coral" strokeWidth={3} /> Pagos validados</div>
                            <div className="flex items-center gap-2"><Smartphone className="w-4 h-4 text-yape" strokeWidth={3} /> Pago Yape</div>
                            <div className="flex items-center gap-2"><Trophy className="w-4 h-4" strokeWidth={3} /> Sorteo transparente</div>
                        </div>
                    </div>

                    <div className="lg:col-span-5 relative">
                        <div className="relative brut-card overflow-hidden rotate-2">
                            <img
                                src="https://images.unsplash.com/photo-1527529482837-4698179dc6ce?w=900&q=80&auto=format&fit=crop"
                                alt="Celebración ganadores"
                                className="w-full h-[420px] object-cover"
                            />
                            <div className="absolute bottom-4 left-4 right-4 bg-paper border-2 border-ink p-3 shadow-brut">
                                <div className="text-[10px] uppercase tracking-widest font-bold opacity-60">Premio del mes</div>
                                <div className="font-display font-black text-2xl">iPhone 15 + S/ 1,500</div>
                            </div>
                        </div>
                        <div className="hidden md:block absolute -top-6 -left-6 brut-card -rotate-6 p-4 bg-mint">
                            <div className="text-[10px] uppercase tracking-widest font-bold">Boleto</div>
                            <div className="font-display font-black text-4xl">042</div>
                        </div>
                        <div className="hidden md:block absolute -bottom-4 -right-4 brut-card rotate-3 p-4 bg-yape text-white">
                            <div className="text-[10px] uppercase tracking-widest font-bold opacity-90">Pago</div>
                            <div className="font-display font-black text-xl">YAPE ✓</div>
                        </div>
                    </div>
                </div>

                {/* Marquee ribbon */}
                <div className="border-t-2 border-ink bg-ink text-paper py-3 overflow-hidden">
                    <div className="marquee-track whitespace-nowrap font-display font-black text-2xl uppercase tracking-tight">
                        {Array.from({ length: 12 }).map((_, i) => (
                            <span key={i} className="px-6">
                                {MARQUEE_TEXT}
                            </span>
                        ))}
                    </div>
                </div>
            </section>

            {/* HOW IT WORKS */}
            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
                    <div>
                        <div className="text-xs uppercase tracking-[0.3em] font-bold opacity-60 mb-2">Cómo funciona</div>
                        <h2 className="font-display font-black text-4xl sm:text-5xl tracking-tight uppercase">3 pasos. Cero vueltas.</h2>
                    </div>
                </div>
                <div className="grid md:grid-cols-3 gap-6">
                    {[
                        { n: "01", t: "Elige tu rifa", d: "Explora las rifas activas o lanza la tuya. Define premio, precio y total de boletos." },
                        { n: "02", t: "Paga con Yape", d: "Escanea el código Yape del organizador y sube tu comprobante. Súper rápido." },
                        { n: "03", t: "Espera el sorteo", d: "Cuando llega la fecha, el sorteo se hace de forma transparente y se anuncia el ganador." },
                    ].map((s, i) => (
                        <div key={i} className="brut-card p-6 space-y-3" data-testid={`step-${i + 1}`}>
                            <div className="font-display font-black text-6xl text-coral">{s.n}</div>
                            <div className="font-display font-black text-2xl">{s.t}</div>
                            <p className="text-ink/70">{s.d}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* FEATURED RAFFLES */}
            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
                    <div>
                        <div className="text-xs uppercase tracking-[0.3em] font-bold opacity-60 mb-2">Rifas destacadas</div>
                        <h2 className="font-display font-black text-4xl sm:text-5xl tracking-tight uppercase">Elige tu suerte</h2>
                    </div>
                    <Link to="/rifas" className="brut-btn text-xs" data-testid="see-all-raffles">
                        Ver todas <ArrowRight className="w-4 h-4" strokeWidth={3} />
                    </Link>
                </div>
                {raffles.length === 0 ? (
                    <div className="brut-card p-12 text-center" data-testid="no-raffles">
                        <Trophy className="w-12 h-12 mx-auto mb-4 text-coral" strokeWidth={2} />
                        <p className="font-display font-black text-2xl">Aún no hay rifas activas</p>
                        <p className="text-ink/70 mt-2">Sé el primero en crear una rifa.</p>
                        <Link to="/crear-rifa" className="brut-btn brut-btn-primary mt-6 inline-flex">
                            Crear primera rifa
                        </Link>
                    </div>
                ) : (
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {raffles.map((r) => (
                            <RaffleCard key={r.id} raffle={r} />
                        ))}
                    </div>
                )}
            </section>

            {/* CTA */}
            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
                <div className="brut-card bg-coral text-white p-10 md:p-16 grain relative overflow-hidden">
                    <h2 className="font-display font-black text-4xl sm:text-6xl uppercase tracking-tight leading-none max-w-3xl">
                        ¿Listo para lanzar tu propia rifa?
                    </h2>
                    <p className="mt-4 max-w-2xl text-lg">
                        Regístrate gratis, sube tu QR de Yape y empieza a vender boletos a toda tu comunidad.
                    </p>
                    <Link to="/register" className="brut-btn bg-white text-ink mt-8" data-testid="cta-bottom-register">
                        Empezar ahora <ArrowRight className="w-4 h-4" strokeWidth={3} />
                    </Link>
                </div>
            </section>
        </div>
    );
}
